<template>
  <div class="departed">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItemScan" @click="onScan">
          <van-image width="25" height="25" :src="scanIcon"></van-image>
        </van-col>
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="getPlaceHolder()"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-tabs
      v-model="menuState"
      @change="stateChanged"
      title-active-color="#009ed4"
      color="#009ed4"
      swipeable
      :ellipsis="false"
    >
      <van-tab
        v-for="(menu, index) in menuList"
        :key="index"
        :title="menu.title + (menu.count > 0 ? ' ' + menu.count : '')"
        :name="menu.name"
      >
        <van-list
          class="list"
          v-model="loading"
          :finished="finished"
          :finished-text="$t.meta.noMore"
          :error.sync="error"
          :error-text="errorText"
          @load="getList(page + 1)"
        >
          <div class="list-container" v-for="(item, index) in tableData" :key="index">
            <div class="checkBox">
              <van-checkbox
                v-model="item.IsChecked"
                @change="handleCheckBox"
              ></van-checkbox>
            </div>
            <div class="container">
              <div class="list-item">
                {{ $t.onlineOrder.wbNumber }}：{{ item.WB_Number }}
              </div>
              <div class="list-item">
                {{ $t.onlineOrder.weight }}：{{ item.AllWeight }}
              </div>
              <div class="list-item">
                {{ $t.onlineOrder.volume }}：{{ item.AllVolume }}
              </div>
              <div class="list-item">
                {{ $t.onlineOrder.numberBoxes }}：{{ item.AllBoxNumber }}
              </div>
              <div class="list-item">
                {{ $t.onlineOrder.cargoQuantity }}：{{ item.TotalCargoQuantity }}
              </div>
              <div class="list-item">
                {{ $t.onlineOrder.departureDate }}：{{ item.CreateTime }}
              </div>
              <div class="list-item">
                {{ $t.onlineOrder.logisticsState }}：{{ item.StateName }}
              </div>
              <div class="list-item">
                {{ $t.onlineOrder.countryCode }}：{{ item.CountryName }}
              </div>
              <div class="list-item">
                {{ $t.onlineOrder.cargoTrackingNumber }}：<span
                  style="
                    word-wrap: break-word;
                    overflow-wrap: break-word;
                    white-space: normal;
                  "
                  >{{ item.CargoTrackingNumber }}</span
                >
              </div>
              <div class="list-item">
                {{ $t.onlineOrder.goodState }}：
                <span v-if="item.OrderState == 2">{{ $t.onlineOrder.state1 }}</span>
                <span v-if="item.OrderState == 3">{{ $t.onlineOrder.state2 }}</span>
                <span v-if="item.OrderState == 4">{{ $t.onlineOrder.state3 }}</span>
                <span v-if="item.OrderState == 5">{{ $t.onlineOrder.state4 }}</span>
              </div>
              <div class="list-item">
                {{ $t.onlineOrder.deliveryMethod }}：
                <span v-if="item.TakeDeliveryType == 1">{{
                  $t.onlineOrder.takeDeliveryType1
                }}</span>
                <span v-if="item.TakeDeliveryType == 2">{{
                  $t.onlineOrder.takeDeliveryType2
                }}</span>
              </div>
              <div class="list-item" v-if="item.PickUpCode">
                {{ $t.onlineOrder.pickUpCode }}：{{ item.PickUpCode }}
              </div>
              <div class="list-item" v-if="item.CompletionTime">
                {{ $t.onlineOrder.completionTime }}：{{ item.CompletionTime }}
              </div>
              <div class="buttons">
                <van-button
                  class="primary-btn"
                  size="small"
                  type="primary"
                  @click="sheetShow(item.WB_Number, item.LogisticsChannel)"
                  >{{ $t.onlineOrder.faceSheet }}</van-button
                >

                <van-button
                  class="primary-btn"
                  size="small"
                  type="primary"
                  @click="gotoDetail(item.WB_Id)"
                  >{{ $t.meta.viewDetail }}</van-button
                >
              </div>
            </div>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.meta.searchType }}</div>
        <van-radio-group v-model="searchType" direction="horizontal">
          <van-radio
            :name="item.value"
            v-for="(item, index) in searchTypeOptions"
            :key="index"
            >{{ item.text }}</van-radio
          >
        </van-radio-group>

        <div class="radio-label">{{ $t.onlineOrder.goodState }}</div>
        <van-radio-group v-model="orderState" direction="horizontal">
          <van-radio :name="2">{{ $t.onlineOrder.state1 }}</van-radio>
          <van-radio :name="3">{{ $t.onlineOrder.state2 }}</van-radio>
          <van-radio :name="4">{{ $t.onlineOrder.state3 }}</van-radio>
          <van-radio :name="5">{{ $t.onlineOrder.state4 }}</van-radio>
        </van-radio-group>

        <van-field
          clickable
          readonly
          :value="selectedCountry.text"
          :label="$t.onlineOrder.country"
          :placeholder="$t.meta.select"
          @click="onShowEmit('showDepartedCountry')"
        />
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <option-list
      event="showDepartedCountry"
      :options="countryList"
      @onSelect="countryConfirm"
    ></option-list>

    <van-dialog
      :title="$t.onlineOrder.dialogSheetTitle"
      width="90%"
      v-model="showSheetDialog"
      @confirm="sheetConfirm"
      @cancel="sheetCancel"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <slot name="default">
        <div class="sheet-alert">
          <van-radio-group v-model="dialogSheetForm.IsPrintVtrackLabel">
            <van-radio :name="0">{{ $t.onlineOrder.isPrintVtrackLabel1 }}</van-radio>
            <van-radio :name="1">{{ $t.onlineOrder.isPrintVtrackLabel2 }}</van-radio>
          </van-radio-group>
        </div>
      </slot>
    </van-dialog>

    <div class="tool-bar" v-if="checkedList && checkedList.length > 0">
      <div class="tool-bar-wrapper">
        <div class="tool-bar-total">
          <div class="tool-bar-total-left">{{ $t.meta.selectTotal }}</div>
          <div
            class="tool-bar-total-item"
            v-for="(item, index) in checkedList"
            :key="index"
          >
            <div class="item1">{{ item.name }}</div>
            <div class="item2">{{ item.value.toFixed(2) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OptionList from "@components/optionList/OptionList.vue";
import {
  List,
  Tab,
  Tabs,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  Popup,
  Picker,
  Radio,
  RadioGroup,
  Checkbox,
  Image,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Tab)
  .use(Tabs)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(Popup)
  .use(Picker)
  .use(Radio)
  .use(RadioGroup)
  .use(Checkbox)
  .use(Image);

export default {
  name: "departed",
  components: {
    OptionList,
  },
  data() {
    return {
      scanIcon: require("@/assets/img/home/scan.png"),
      UserName: JSON.parse(localStorage.getItem("auth")).userInfo.UserName,
      menuState: this.$route.query.state
        ? this.$route.query.state
        : parseInt(localStorage.getItem("MenuState")),
      menuList: [
        {
          title: this.$t.onlineOrder.tab1,
          name: 1,
          count: 0,
        },
      ],
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      searchText: "",
      searchType: 1,
      searchTypeOptions: [
        {
          text: this.$t.onlineOrder.wbNumber,
          value: 1,
        },
        {
          text: this.$t.onlineOrder.cargoTrackingNumber,
          value: 2,
        },
      ],
      showFilter: false,
      selectedCountry: { text: "", value: null },
      orderState: null,
      countryList: [],
      //picker
      showDepartedCountry: false,
      //多选
      checkedList: [],
      //查看面单
      showSheetDialog: false,
      dialogSheetForm: {
        WB_Number: "",
        IsPrintVtrackLabel: 0,
      },
    };
  },
  watch: {
    menuState() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
      this.getList(1);
    },
    $route(to, from) {
      if (this.$route.query && to && from) {
        const { SearchText } = this.$route.query;
        if (SearchText) {
          this.searchText = SearchText;
          this.loading = true;
          this.finished = false;
          this.error = false;
          this.tableData = [];
          this.getList(1);
        }
      }
    },
  },
  created() {
    this.initCheckList();
    this.getCountryList();
  },
  methods: {
    sheetConfirm() {
      this.showSheetDialog = false;
      this.gotoPrint(this.dialogSheetForm.WB_Number);
    },
    sheetCancel() {
      this.showSheetDialog = false;
    },
    sheetShow(num, id) {
      if (id > 0) {
        this.dialogSheetForm.WB_Number = num;
        this.showSheetDialog = true;
      } else {
        this.dialogSheetForm.WB_Number = "";
        this.gotoPrint(num);
      }
    },
    onScan() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.scanToPage, {
        options: {
          baseColor: "#009ed4",
          choosePhotoEnable: "true",
          flashlightEnable: "true",
          title: this.$t.onlineOrder.scanTitle2,
          describe: this.$t.meta.scanDes,
          choosePhotoBtnTitle: this.$t.meta.scanButton,
        },
        path: "departed",
        errorText: this.$t.meta.scanError1,
        authText: this.$t.meta.scanError2,
      });
    },
    gotoPrint(id) {
      var param = {
        WB_Number: id,
        OperationUserName: this.UserName,
        Type: 2,
        FileType: 2,
        IsReturnBase64str: 1,
      };
      if (this.dialogSheetForm.WB_Number) {
        param.IsPrintVtrackLabel = this.dialogSheetForm.IsPrintVtrackLabel;
      }
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "base64Print",
        name: "base64Print",
        query: [
          {
            name: "Api",
            value: "createBarCodePdf",
          },
          {
            name: "Param",
            value: JSON.stringify(param),
          },
        ],
      });
    },
    gotoDetail(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "departedDetail",
        name: "departedDetail",
        query: [
          {
            name: "WB_Id",
            value: id,
          },
        ],
      });
    },
    initCheckList() {
      this.checkedList = [
        {
          id: 1,
          name: this.$t.onlineOrder.weight + " Kg",
          value: 0,
        },
        {
          id: 2,
          name: this.$t.onlineOrder.volume + " m³",
          value: 0,
        },
        {
          id: 3,
          name: this.$t.onlineOrder.numberPackagesSn,
          value: 0,
        },
      ];
    },
    handleCheckBox() {
      var list = [];
      var items = this.tableData.filter((p) => p.IsChecked);
      if (items.length > 0) {
        var C1 = {
          id: 1,
          name: this.$t.onlineOrder.weight + " Kg",
          value: 0,
        };
        var C2 = {
          id: 2,
          name: this.$t.onlineOrder.volume + " m³",
          value: 0,
        };
        var C3 = {
          id: 3,
          name: this.$t.onlineOrder.numberPackagesSn,
          value: 0,
        };
        for (var item of items) {
          if (item.AllWeight) {
            C1.value = C1.value + parseFloat(item.AllWeight);
          }
          if (item.AllVolume) {
            C2.value = C2.value + parseFloat(item.AllVolume);
          }
          if (item.AllBoxNumber) {
            C3.value = C3.value + parseFloat(item.AllBoxNumber);
          }
        }
        list.push(C1);
        list.push(C2);
        list.push(C3);
        this.checkedList = list;
      } else {
        this.initCheckList();
      }
    },
    getPlaceHolder() {
      var search = this.searchTypeOptions.find((c) => c.value == this.searchType);
      if (search) {
        return search.text;
      } else {
        return this.$t.meta.searchText;
      }
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    isFilter() {
      if (this.selectedCountry.value || this.orderState) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.searchType = 1;
      this.selectedCountry = { text: "", value: null };
      this.orderState = null;
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
      this.initCheckList();
    },
    pickerShow(pickerName) {
      this[pickerName] = true;
    },
    countryConfirm(e) {
      this.selectedCountry.text = e.text;
      this.selectedCountry.value = e.value;
      this.showDepartedCountry = false;
      this.$forceUpdate();
    },
    getCountryList() {
      return new Promise((resolve) => {
        this.$api.customerManagement
          .getCountryList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CountryName + "," + item.CountryName_en,
                value: item.CountryId,
              };
              result.push(data);
            });
            this.countryList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    stateChanged(state) {
      this.menuState = state;
      localStorage.setItem("MenuState", JSON.stringify(state));
      this.searchText = "";
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        WB_Number: this.searchType == 1 ? this.searchText : "",
        CargoTrackingNumber: this.searchType == 2 ? this.searchText : "",
        CountryId: this.selectedCountry.value,
        OrderState: this.orderState,
      };
      var request = null;
      if (this.menuState == 1) {
        request = this.$api.onlineOrderManagement.getCustomerOrderHasShippedListByPage(
          param
        );
      }
      request
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.departed {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItemScan {
        width: 15%;
        margin: auto;
        text-align: center;
        .van-icon {
          color: #323233;
          font-weight: bold;
        }
      }
      .colItem1 {
        width: 65%;
        text-align: center;
        font-size: 14px;
        .van-search {
          padding: 10px 0px;
          .van-search__content {
            padding: 0px;
            margin-right: 10px;
            .van-cell {
              padding: 5px 8px 5px 8px;
            }
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .sheet-alert {
    overflow: scroll;
    margin: 26px 16px 0px 0px;
    text-align: center;
    .van-radio-group {
      display: inline-block;
      margin: 0;
      .van-radio {
        margin-bottom: 26px;
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      .checkBox {
        vertical-align: middle;
        display: inline-block;
        margin: 15px;
      }
      .container {
        padding: 10px;
        box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
        .list-item {
          margin-bottom: 10px;
        }
        .list-item:last-child {
          margin-bottom: 0px;
        }
        .buttons {
          text-align: right;
          .primary-btn {
            margin-left: 5px;
            border-radius: 5px;
            background: $-color-primary;
            border: none;
            .van-button__text {
              font-size: 14px !important;
            }
          }
          .default-btn {
            margin-left: 5px;
            border-radius: 5px;
            background: $-color-light-gray;
            border: none;
            .van-button__text {
              font-size: 14px !important;
            }
          }
          .search-btn {
            margin-left: 5px;
            border-radius: 5px;
            background: $-color-green;
            border: none;
            .van-button__text {
              font-size: 14px !important;
            }
          }
          .danger-btn {
            margin-left: 5px;
            border-radius: 5px;
            background: $-color-red;
            border: none;
            .van-button__text {
              font-size: 14px !important;
            }
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .tool-bar-total {
    font-size: 12px;
    color: #333333;
    background: #fff;
    .tool-bar-total-left {
      display: inline-block;
      width: 25%;
      text-align: center;
      vertical-align: middle;
      .checkbox {
        display: inline-flex;
        span {
          margin-left: 10px;
        }
      }
    }
    .tool-bar-total-item {
      display: inline-block;
      width: 25%;
      text-align: center;
      vertical-align: middle;
      .item1 {
        padding: 5px;
        background: #1e90ff;
        color: #ffffff;
      }
      .item2 {
        padding: 5px;
        background: #e8f4ff;
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .tool-bar-wrapper {
      border-top: 1px solid #f6f6f6;
      border-bottom: 1px solid #f6f6f6;
    }
  }
}
</style>
